module.exports = __webpack_public_path__ + "static/media/search.4a9ea4b9.svg";